import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Html } from '@react-three/drei';
import * as THREE from 'three';

/**
 * Inline text-entry box anchored to a 3D position, shown while the Text
 * (annotate) tool waits for user input. Enter or OK commits the note,
 * Escape cancels. The result travels back to the tool through a window
 * CustomEvent ('yap:text-note-input'); a null text means cancel.
 */
export function TextNoteInput({ position }: { position: THREE.Vector3 | [number, number, number] }) {
    const { t } = useTranslation();
    const [value, setValue] = useState('');

    const commit = (text: string | null) => {
        window.dispatchEvent(new CustomEvent('yap:text-note-input', { detail: { text } }));
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        // Keep keystrokes inside the field: without this, the viewport's
        // global keydown router (tool hotkeys / command buffer) would fire
        // while the user is typing.
        e.stopPropagation();
        if (e.key === 'Enter') commit(value.trim() || 'Text Note');
        else if (e.key === 'Escape') commit(null);
    };

    return (
        <Html position={position as any} center>
            <div className="text-input-overlay" onPointerDown={(e) => e.stopPropagation()}>
                <input
                    autoFocus
                    type="text"
                    value={value}
                    placeholder={t('misc.enterTextEnterToPlace')}
                    className="text-input-overlay__input"
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
                <div className="text-input-overlay__actions">
                    <button
                        className="text-input-overlay__button"
                        onClick={() => commit(value.trim() || 'Text Note')}
                    >{t('misc.oK')}</button>
                </div>
            </div>
        </Html>
    );
}
